import { render, staticRenderFns } from "./eod-storage-object.vue?vue&type=template&id=33012a24"
import script from "./eod-storage-object.vue?vue&type=script&lang=js"
export * from "./eod-storage-object.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports